/**
 * Utility functions for handling durations in graphs/charts, tables, global prefs
 */
export default {
    name: "DurationDefaults",
    methods: {

        /**
         * Mutates duration object passed by adding default values for interval options if unspecified
         * @param {String} duration 
         */
        setDurationDefaults(duration) {
            switch (duration.id) {
                case 'last24Hours':
                    duration.showMinutes = duration.showMinutes === undefined ? true : duration.showMinutes
                    duration.showHours = duration.showHours === undefined ? true : duration.showHours
                    duration.showDays = duration.showDays === undefined ? false : duration.showDays
                    break
                case 'last1Days':
                    duration.showMinutes = duration.showMinutes === undefined ? false : duration.showMinutes
                    duration.showHours = duration.showHours === undefined ? false : duration.showHours
                    duration.showDays = duration.showDays === undefined ? true : duration.showDays
                    break
                case 'last7Days':
                    duration.showMinutes = duration.showMinutes === undefined ? true : duration.showMinutes
                    duration.showHours = duration.showHours === undefined ? true : duration.showHours
                    duration.showDays = duration.showDays === undefined ? true : duration.showDays
                    break
                case 'last30Days':
                    duration.showMinutes = duration.showMinutes === undefined ? false : duration.showMinutes
                    duration.showHours = duration.showHours === undefined ? true : duration.showHours
                    duration.showDays = duration.showDays === undefined ? true : duration.showDays
                    break
                case 'custom':
                    duration.showMinutes = duration.showMinutes === undefined ? true : duration.showMinutes
                    duration.showHours = duration.showHours === undefined ? true : duration.showHours
                    duration.showDays = duration.showDays === undefined ? true : duration.showDays
                    break
                default:
                    break
            }
        },

        /**
         * Maps interval name to associated interval option
         * Sample use case: 'MINUTE' interval associated with showMinutes option; 
         * if 'MINUTE' interval is desired, check showMinutes property to see if the interval option is allowed
         * @param {String} interval 
         */
        mapIntervalToProperty(interval) {
            let property = ''

            switch (interval) {
                case 'MINUTE':
                    property = 'showMinutes';
                    break;
                case 'HOUR':
                    property = 'showHours';
                    break;
                case 'DAY':
                    property = 'showDays';
                    break;
                default:
                    break;
            }

            return property;
        },

        /**
         * Returns duration options specifically for global user prefs
         */
        getDurationPrefOptions() {
            // any changes made here will effect in the created method of GlobalPrefsDialog.vue file  
            return [
                {id: 'last24Hours', interval: 'HOUR', title: this.$t('prefs.duration.days1IntervalHourly')},
                {id: 'last7Days', interval: 'HOUR', title: this.$t('prefs.duration.days7IntervalHourly')},
                {id: 'last7Days', interval: 'DAY', title: this.$t('prefs.duration.days7IntervalDaily')},
                {id: 'last30Days', interval: 'HOUR', title: this.$t('prefs.duration.days30IntervalHourly')},
                {id: 'last30Days', interval: 'DAY', title: this.$t('prefs.duration.days30IntervalDaily')}
            ]
        }
    }
}